import { DateFilterField } from '../../../components/tables/filterForms/DateFilterField';
import { FilterField } from '../../../components/tables/filterForms/FilterForm';
import { Filter } from '../../../types/api.type';
import { getFilterValue } from '../../listFilterSearchParams';

export const imageFilterFields: Array<FilterField> = [
  {
    name: 'image_file_name',
    label: 'Image File Name'
  },
  {
    name: 'image_content_type',
    label: 'Image Content Type'
  },
  {
    name: 'image_file_size',
    label: 'Image File Size',
    type: 'number'
  },
  {
    name: 'image_updated_at_from',
    id: 'image_updated_at',
    operator: 'greater_equal_than',
    element: (
      <DateFilterField
        name="image_updated_at_from"
        label="Image Updated At"
      />
    )
  },
  {
    name: 'image_updated_at_to',
    id: 'image_updated_at',
    operator: 'lesser_equal_than',
    element: <DateFilterField name="image_updated_at_to" />
  }
];

/** Hydrate shared image filter fields from URL/list filter state. */
export const getImageFilterFields = (filterBy?: Filter[]): FilterField[] =>
  imageFilterFields.map((field) => ({
    ...field,
    value: getFilterValue(filterBy, field.id ?? field.name, field.operator)
  }));
